<script setup lang="ts">
import {DateFormatter, type DateValue, getLocalTimeZone,} from '@internationalized/date';
import {CalendarIcon} from '@lucide/vue';

import {Popover, PopoverContent, PopoverTrigger} from "@/core/components/ui/popover";
import {Calendar} from "@/core/components/ui/calendar";
import {Button} from "@/core/components/ui/button";
import {cn} from "@/lib/utils";
import {ref} from "vue";

const {dateStyle = 'long'} = defineProps<{
    triggerClass?: HTMLElement['className'],
    dateStyle?: 'short' | 'medium' | 'long' | 'full';
    minValue?: DateValue;
}>();

const df = new DateFormatter('fr-FR', {
    dateStyle
});

const open = ref<boolean>(false);
const value = defineModel<DateValue | undefined>();
</script>

<template>
  <Popover v-model:open="open" modal>
    <PopoverTrigger>
      <Button
        variant="outline"
        :class="cn(
          'w-[280px] justify-start text-left font-normal flex',
          !value && 'text-muted-foreground',
          triggerClass,
        )"
      >
        {{ value ? df.format(value.toDate(getLocalTimeZone())) : "Choisissez une date" }}
        <CalendarIcon class="h-4 w-4" />
      </Button>
    </PopoverTrigger>
    <PopoverContent class="w-auto p-0">
      <Calendar v-model="value" locale="fr-FR" :min-value="minValue" initial-focus @update:model-value="date => open = false" />
    </PopoverContent>
  </Popover>
</template>
